export default "__VITE_ASSET__BdtEJfzV__"